import { useLingui } from '@lingui/react/macro'
import { useMemo } from 'react'

export function useSupportedCountries() {
  const { t } = useLingui()

  return useMemo(() => {
    return [
      // EU Countries
      {
        label: t`Austria`,
        value: 'AT'
      },
      {
        label: t`Belgium`,
        value: 'BE'
      },
      {
        label: t`Bulgaria`,
        value: 'BG'
      },
      {
        label: t`Croatia`,
        value: 'HR'
      },
      {
        label: t`Cyprus`,
        value: 'CY'
      },
      {
        label: t`Czechia`,
        value: 'CZ'
      },
      {
        label: t`Denmark`,
        value: 'DK'
      },
      {
        label: t`Estonia`,
        value: 'EE'
      },
      {
        label: t`Finland`,
        value: 'FI'
      },
      {
        label: t`France`,
        value: 'FR'
      },
      {
        label: t`Germany`,
        value: 'DE'
      },
      {
        label: t`Greece`,
        value: 'GR'
      },
      {
        label: t`Hungary`,
        value: 'HU'
      },
      {
        label: t`Ireland`,
        value: 'IE'
      },
      {
        label: t`Italy`,
        value: 'IT'
      },
      {
        label: t`Latvia`,
        value: 'LV'
      },
      {
        label: t`Lithuania`,
        value: 'LT'
      },
      {
        label: t`Luxembourg`,
        value: 'LU'
      },
      {
        label: t`Malta`,
        value: 'MT'
      },
      {
        label: t`Netherland`,
        value: 'NL'
      },
      {
        label: t`Poland`,
        value: 'PL'
      },
      {
        label: t`Portugal`,
        value: 'PT'
      },
      {
        label: t`Romania`,
        value: 'RO'
      },
      {
        label: t`Slovakia`,
        value: 'SK'
      },
      {
        label: t`Slovenia`,
        value: 'SI'
      },
      {
        label: t`Spain`,
        value: 'ES'
      },
      {
        label: t`Sweden`,
        value: 'SE'
      },

      // Other Countries with reverse charge
      {
        label: t`Thailand`,
        value: 'TH'
      },
      {
        label: t`Australia`,
        value: 'AU'
      },
      {
        label: t`Singapore`,
        value: 'SG'
      },
      {
        label: t`Canada`,
        value: 'CA'
      },
      {
        label: t`Switzerland`,
        value: 'CH'
      },
      {
        label: t`United Kingdom`,
        value: 'GB'
      },
      {
        label: t`New Zealand`,
        value: 'NZ'
      },
      {
        label: t`Norway`,
        value: 'NO'
      }

      // Not sure
      // {
      //   label: t`USA`,
      //   value: 'US'
      // },
      // {
      //   label: t`Japan`,
      //   value: 'JP'
      // }
    ].toSorted((a, b) => a.label.localeCompare(b.label))
  }, [t])
}
